import { render } from "./LodingLayout.vue?vue&type=template&id=611a5ae0"
import script from "./LodingLayout.vue?vue&type=script&lang=js"
export * from "./LodingLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__